import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { QUICK_POST_V3_MODAL_EXIT_MS } from "@circle-react/components/QuickPostV3/constants";
import { useCallback, useEffect, useRef } from "react";

interface UseDeferredCompassModalCloseOptions {
  exitMs?: number;
}

export const useDeferredCompassModalClose = ({
  exitMs = QUICK_POST_V3_MODAL_EXIT_MS,
}: UseDeferredCompassModalCloseOptions = {}) => {
  const modal = useModal();
  const removeTimeoutRef = useRef<number | null>(null);

  useEffect(() => {
    if (modal.visible && removeTimeoutRef.current) {
      window.clearTimeout(removeTimeoutRef.current);
      removeTimeoutRef.current = null;
    }
  }, [modal.visible]);

  useEffect(
    () => () => {
      if (removeTimeoutRef.current) {
        window.clearTimeout(removeTimeoutRef.current);
      }
    },
    [],
  );

  const hide = useCallback(() => {
    void modal.hide();

    if (removeTimeoutRef.current) {
      window.clearTimeout(removeTimeoutRef.current);
    }

    removeTimeoutRef.current = window.setTimeout(() => {
      removeTimeoutRef.current = null;
      modal.remove();
    }, exitMs);
  }, [modal, exitMs]);

  return { isOpen: modal.visible, hide };
};
